import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/laborhack-white-logo.png";
import { NAV_MENU } from "../constants";
import { useProfile } from "../hooks/useProfile";
import { useToggles } from "../hooks/useToggles";
import { Loading } from "./Loading";
import { HelpCenterV2 } from "./HelpCenterV2";
import { IoLogOut } from "react-icons/io5";
import { SideNavItemV2 } from "./NavItem/SideNavItem";

export interface SideNavProps {}

export const SideNavV2 = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { logout, user } = useAuth0();
	const { profile, loading: profileLoading } = useProfile();

	const { isLoading: isLoadingToggles, toggles } = useToggles();

	if (isLoadingToggles) {
		return <Loading />;
	}

	if (!user) {
		return null;
	}

	const isActive = (url: string) => {
		if (url === "/") {
			return location.pathname === url;
		}

		return location.pathname.startsWith(url);
	};

	const handleSubItemClick = (url: string) => {
		url.startsWith("http") ? window.open(url, "_blank") : navigate(url);
	};

	return (
		<div className="w-full h-[100dvh] bg-[#F9F9F9] border-r-[1px] border-[#E7E7E7]  flex flex-col">
			<div className="bg-[#ED6E5C] px-8 py-8 flex h-8 items-center">
				<img src={logo} width="120px" alt="laborhack's logo" />
			</div>
			<div className="flex-auto py-8 overflow-auto">
				<ul className="flex flex-col gap-3">
					{NAV_MENU.filter(
						({ shouldRender }) =>
							!profileLoading && shouldRender(profile, toggles)
					).map((item) => {
						const hasSubItems = item.subItems && item.subItems.length > 0;
						const itemActive = item.url ? isActive(item.url) : false;
						// Check if any sub-item is active
						const subItemActive =
							hasSubItems &&
							item.subItems?.some((subItem) => isActive(subItem.url));
						const active = itemActive || subItemActive || false;

						return (
							<li key={item.name} className="w-full">
								<SideNavItemV2
									name={item.name}
									path={item.url}
									locked={!profileLoading && item.shouldLock(profile)}
									active={active}
									icon={item.icon}
									subItems={hasSubItems ? item.subItems : undefined}
									isActive={isActive}
									onSubItemClick={handleSubItemClick}
								/>
							</li>
						);
					})}
				</ul>
			</div>
			<div className="flex items-center justify-center px-4 py-6 border-y-[1px] border-y-[#E7E7E7]">
				<HelpCenterV2 />
			</div>
			<div className="my-4 px-4 w-fit">
				<Button
					width={"fit"}
					background={"none"}
					borderRadius={0}
					px={3}
					fontSize={"sm"}
					onClick={() =>
						logout({
							returnTo: window.location.origin,
						})
					}
					gap={"16px"}
					_hover={{ backgroundColor: "#464646", textColor: "#FEFEFE" }}
				>
					<IoLogOut size={20} style={{ transform: "rotate(180deg)" }} />
					<p className="font-medium text-lg">Log Out</p>
				</Button>
			</div>
		</div>
	);
};
